import { GlobalState } from '../../rootReducer';

export const getCurrentPath = (state: GlobalState) => state.router.location.pathname;
